
import React from 'react';

import { Header } from "../components/componentHeader/Header";
import { CartRead } from '../components/ComponentCartBy/CartRead'
import { Infoview } from "../components/componentBody/Infoview";
import { Video } from "../components/componentVideo/Video";
import { Audio } from "../components/componentAudio/Audio";
import { Table } from "../components/componentTable/Table";
import { Contact } from "../components/componentContat/Contact";
import { Footer } from "../components/componentFooter/Footer";
export function Read() {

  return (
    <>
        <Header/>
        <CartRead />
        <Infoview />
        <Video />
        <Audio />
        <Table />
        <Contact />
        <Footer />
    </>
  );

}
